/**
 * Footer
 */

export default function Footer() {
    const selectors = {
        'scrollToTop' : '.js-scroll-to-top',
        'scrollToTopDesktop' : '.scroll-to-top-desktop',
    };

    this.init = () => {
        this.scrollToTop();
    };

    this.scrollToTop = () => {
        jQuery(selectors.scrollToTop).click(function(){
            jQuery('html, body').animate({scrollTop:0}, 'slow');
            return false;
        });
        jQuery(window).scroll(() => {
            this.handleScrollable();
        });
        this.handleScrollable();
    }

    this.handleScrollable = () => {
        if(jQuery(window).scrollTop() > 100){
            jQuery(selectors.scrollToTopDesktop).css({"opacity": 1});
        }else{
            jQuery(selectors.scrollToTopDesktop).css({"opacity": 0});
        }
    }

}
